import {Link as RouterLink, useNavigate} from 'react-router-dom';
import {Button, Link} from '@mui/material';
import {MRT_ColumnDef} from 'material-react-table';

import {Category, useGetCategories} from '@entities/category';
import {MrTable} from '@shared/components';
import {
  entityTableCommonProps,
  ROUTE__CATEGORY_CREATE,
  ROUTE__CATEGORY_EDIT,
} from '@shared/constants';
import {BaseComponentLayout} from '@shared/layouts';

const columns: MRT_ColumnDef<Category>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    Cell: ({row}) => (
      <Link
        component={RouterLink}
        to={ROUTE__CATEGORY_EDIT.replace(':id', row.original.id)}
        sx={{display: 'flex', alignItems: 'center', gap: 1}}
      >
        {row.original.logoUrl && (
          <img
            src={row.original.logoUrl}
            alt=""
            width="auto"
            height={24}
            style={{flexShrink: 0}}
          />
        )}
        {row.original.name}
      </Link>
    ),
  },
  {
    accessorKey: 'order',
    header: 'Order',
    size: 80,
  },
  {
    accessorKey: 'description',
    header: 'Description',
  },
];

export const CategoryTable = () => {
  const navigate = useNavigate();
  const {data, isPending, error} = useGetCategories();

  const renderContent = (categories: Category[] | undefined) => {
    if (!categories) {
      return null;
    }

    return (
      <MrTable
        columns={columns}
        data={categories}
        renderTopToolbarCustomActions={() => {
          return (
            <Button onClick={() => navigate(ROUTE__CATEGORY_CREATE)}>
              Create category
            </Button>
          );
        }}
        {...entityTableCommonProps}
        enableRowActions={false}
      />
    );
  };

  return (
    <BaseComponentLayout isPending={isPending} error={error}>
      {renderContent(data)}
    </BaseComponentLayout>
  );
};
